import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { CustomReactSelect } from '../../';
import { 
    getGileClassesFetch,
    getGileClassesFetchSelector,
} from '../../../../reduxtoolkit/slices/gq-admin/gile-class';
import { showErrorToast } from '../../../../utils/utils';
import classes from './CustomFormSelect.module.scss';

const CustomFormSelect = (props) => {
    const { inputData, formik, data } = props;
    const dispatch = useDispatch();
    const [selectValue, setSelectValue] = useState(null);
    const [isApiLoading, setIsApiLoading] = useState(false);
    const [selectOptions, setSelectOptions] = useState(inputData?.input_value?.length > 0 ? inputData?.input_value : []);

    const onClear = (e, context) => {
        setSelectValue(null);
        formik.setFieldValue(context?.name, '');
    }

    const handleReactSelectChange = async (e, context) => {
        if (context?.action === 'clear') {
            onClear(e, context);
        } else {
            setSelectValue(e);
            formik.setFieldValue(context?.name, e?.value);
        }
    };

    useEffect(() => {
        if (inputData?.input_name === 'class') {
            // fetch class list
            const fetchClassesList = async (payload) => {
                try {
                    const getGileClassesFetchRes = await dispatch(getGileClassesFetch(payload)).unwrap();
                    if (getGileClassesFetchRes?.status_code === 200 && getGileClassesFetchRes?.data) {
                        setSelectOptions(getGileClassesFetchRes?.data || []);
                    }
                } catch (error) {
                    console.error("fetchClassesList error", error);
                    if (error?.status_code !== 401 || error?.status_code !== 403) {
                        showErrorToast(error?.message || "Oops! Something went wrong");
                    }
                }
            }
    
            fetchClassesList({
                ...(data?.institute_config?.group_code && { group_code: data?.institute_config?.group_code }),
                ...(data?.institute_config?.institute_code && { institute_code: data?.institute_config?.institute_code }),
                ...(data?.institute_config?.location_code && { location_code: data?.institute_config?.location_code }),
                ...(data?.institute_config?.education_type_code && { education_type_code: data?.institute_config?.education_type_code }),
            });
        }
    }, [])
    

    return (
        <div className={classes.CustomFormSelect}>
            {inputData?.label ? 
                (<label htmlFor={inputData?.input_id}>
                    {inputData?.label}
                    {inputData?.is_required ? <span className='required'>*</span> : null}
                </label>) 
            : null}
            <CustomReactSelect 
                inputId={inputData?.input_id}
                name={inputData?.input_name}
                maxMenuHeight={200}
                onChange={handleReactSelectChange}
                options={selectOptions || []}
                value={selectOptions ? selectOptions?.find((ele) =>ele?.value === formik?.values[inputData?.input_name]) : null}
                placeholder={`Select ${inputData?.label}`}
                isClearable={true}
                isLoading={isApiLoading}
                isDisabled={isApiLoading}
            />
            {inputData?.helper_text ? (
                <span className='helper-text'>{inputData?.helper_text}</span>
            ) : null}
            {formik.touched[inputData?.input_name] && formik.errors[inputData?.input_name] ? (
                <span className="form-error">{formik.errors[inputData?.input_name]}</span>
            ) : null}
        </div>
    )
}

CustomFormSelect.propTypes = {}

export default CustomFormSelect;